'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = require('./radio');

var _radio2 = _interopRequireDefault(_radio);

var _group = require('./group');

var _group2 = _interopRequireDefault(_group);

var _radioButton = require('./radioButton');

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_radio2["default"].Button = _radioButton2["default"];
_radio2["default"].Group = _group2["default"];
exports["default"] = _radio2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/radio/index.jsx
 ** module id = 25
 ** module chunks = 0
 **/